<template>
  <div>
    <b-field
      :label="label"
      :type="(hasError() ? 'is-danger': '')"
      :message="errorMessage()"
    >
      <b-rate
        :value="value"
        :max="max"
        :name="name"
        @change="inputListener"
      />
    </b-field>
  </div>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator () {
        return true;
      }
    },
    max: {
      type: Number,
      default: 5
    },
  }
};
</script>
